import { ComboboxData, Select, SelectProps } from "@mantine/core"
import { useGetConditionsSuspense } from "@/orval/gen"

export function ConditionSelect(props: SelectProps) {
  const { data: conditions } = useGetConditionsSuspense()
  const options: ComboboxData = conditions.map((c) => ({
    label: c.conditionName,
    value: c.conditionId.toString(),
  }))

  return <Select data={options} {...props} />
}
